import { render, staticRenderFns } from "./OurProductsSection.vue?vue&type=template&id=7643ce5a&scoped=true"
import script from "./OurProductsSection.vue?vue&type=script&lang=js"
export * from "./OurProductsSection.vue?vue&type=script&lang=js"
import style0 from "./OurProductsSection.vue?vue&type=style&index=0&id=7643ce5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7643ce5a",
  null
  
)

export default component.exports